export default {
  salesMan: {
    salesmanName: 'Salesman Name',
    telephone: 'Telephone',
    regionName: 'Region Name',
    mobile: 'Mobile',
    entryDay: 'Entry Day',
    createTime: 'Create Time',
    modifyTime: 'Modify Time',
    onTheJob: 'On The Job',
    resign: 'Resign',
    Deleted: 'Deleted',
    loginAccount: 'Login Account',
    loginPassword: 'Login Password',
    enclosureList: 'Enclosure List',
    uploadEnclosure: 'Upload Enclosure',
    birthday: 'Birthday',
    fullName: 'Full Name',
    IDcard: 'ID Card',
    enclosureType: 'Enclosure Type',
    enclosureName: 'Enclosure Name',
    enclosureSize: 'Enclosure Size',
    uploader: 'Uploader',
    uploadTime: 'Upload Time'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/cmc/salesman.js